// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://ynbdental-backend.onrender.com/",
});

export default axiosInstance;

// export const weburl = "https://backend-2o7f.onrender.com/";
export const weburl = "https://ynbdental-backend.onrender.com/";

export const shopurl = "https://admin.ynbdental.com/";
export const mainurl = "https://admin.ynbdental.com/";
export const fronturl = "https://ynbdental.com/";
export const socketURL = "https://ynbdental-backend.onrender.com/";

export const keyLogin = process.env.REACT_APP_LOGIN_KEY;